export default __webpack_public_path__ + "static/media/spaceship.1596e7fa.png";